// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Header_wrap__3Rphd","title":"Header_title__3cRR8","button":"Header_button__33Ndl","icon":"Header_icon__fntcn"};